<template>
    <div v-if="saving" class="loader">
        <FadeLoader :loading="saving"></FadeLoader>
    </div>
    <div class="languages-container">
        <div class="language-row" v-if="defaultLanguage">
            <h4>Default Language:</h4>
            <select v-model="defaultLanguage_local" @change="changeDefault" :disabled="saving">
                <option v-for="lang in languages" :key="lang.name">{{ lang.name }}</option>
            </select>
        </div>
        <div class="language-row">
            <h4>Languages:</h4>
            <div>
                <div v-for="lang in languages" :key="lang.name">
                    {{ lang.name }} 
                    <button v-if="lang.name !== 'English' && lang.name !== defaultLanguage" class="remove-language-button" @click="deleteLanguage(lang.name)"><i class="fas fa-lg fa-trash-can"></i></button>
                </div>
            </div>
            <div>
                <button class="add-language-button" @click="addingLanguage = true" v-if="!addingLanguage && otherLanguages.length > 0">Add Language</button>
                <select v-model="selectedLanguage" v-if="addingLanguage" @change="addLanguage" :disabled="saving">
                    <option v-for="lang in otherLanguages" :key="lang.name">{{ lang.name }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import FadeLoader from 'vue-spinner/src/FadeLoader.vue';

export default {
    name: 'LanguageManagement',
    components: { FadeLoader },
    props: {
        onLanguageAdd: {
            type: Function,
            required: true
        },
        objectLanguageArray: {
            type: Array,
            required: true
        },
        defaultLanguage: {
            type: String
        },
        onDefaultChange: {
            type: Function
        },
        onLanguageDelete: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            allLanguages: null,
            addingLanguage: false,
            selectedLanguage: null,
            defaultLanguage_local: null,
            saving: false
        }
    },
    computed: {
        languages: function() {
            if(!this.allLanguages || !this.objectLanguageArray)
                return [];
            return this.allLanguages.filter(lng => this.objectLanguageArray.indexOf(lng.name) >= 0);
        },
        otherLanguages: function() {
            if(!this.allLanguages || !this.objectLanguageArray)
                return [];
            return this.allLanguages.filter(lng => this.objectLanguageArray.indexOf(lng.name) < 0);
        },
    },
    async mounted() {
        this.allLanguages = await data.getLanguages();
        this.defaultLanguage_local = this.defaultLanguage;
    },
    methods: {
        addLanguage: async function() {
            this.saving = true;
            await this.onLanguageAdd(this.selectedLanguage);
            this.selectedLanguage = null;
            this.addingLanguage = false;
            this.saving = false;
        },
        changeDefault: async function() {
            if(!this.defaultLanguage) return;
            this.saving = true;
            await this.onDefaultChange(this.defaultLanguage_local);
            this.saving = false;
        },
        deleteLanguage: async function(lang) {
            this.saving = true;
            await this.onLanguageDelete(lang);
            this.saving = false;
        }
    }
}
</script>

<style scoped>
    .loader{
        height: 8em;
        width: 20%;
        position: absolute;
        background-color: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .languages-container {
        display:flex;
        flex-direction:column;
        width: 100%;
    }
    .language-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .language-row select {
        height: 2em;
    }
    .add-language-button {
        height: 30px;
        border-radius: 5px;
        color: white;
        background-color: #036991;
        border-color: #036991;
        font-size: 12px;
        cursor: pointer;
        margin-bottom: 10px;
    }
    .remove-language-button {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color:darkred;
    }
</style>